export default __webpack_public_path__ + "static/media/Blog9.11258c2e.png";